
export default function SuccessFactorsSection() {
  const factors = [
    {
      icon: 'ri-search-line',
      title: '徹底した事前調査',
      description: '企業の財務状況、事業内容、市場価値を詳細に分析し、適正な価格設定を実現します。'
    },
    {
      icon: 'ri-team-line',
      title: '最適なマッチング',
      description: '売手と買手のニーズを深く理解し、双方にとって最良の相手を見つけ出します。'
    },
    {
      icon: 'ri-time-line',
      title: 'スピード対応',
      description: '平均45日での成約を実現。迅速かつ丁寧なサポートで、お客様の時間を大切にします。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心のサポート',
      description: '契約から引き継ぎまで、専門家が全プロセスをサポート。成約後も安心です。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">成約の成功要因</h2>
          <p className="text-lg text-gray-600">NEXTAGEが高い成約率を実現できる理由</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {factors.map((factor, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className={`${factor.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{factor.title}</h3>
              <p className="text-gray-600 leading-relaxed">{factor.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
